import { ComponentType, lazy, LazyExoticComponent } from "react"

import { isChunkLoadError, reloadForStaleAssets } from "@/utils/chunkLoadError"

export function lazyWithRetry<T extends ComponentType<any>>(
    factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
    return lazy(() =>
        factory().catch(error => {
            if (isChunkLoadError(error)) {
                reloadForStaleAssets()
            }

            throw error
        })
    )
}
